import { memo } from "react"
import { main } from "../../../assets/coach-assets/constants/colors"
import { FaCheck, FaTimes } from "react-icons/fa";
import { fontType } from "../../../assets/extras";

const ClasesMuestraConfirm = ({
    variables,
    setVariables,
    onContinue
}) => {

    //Funcion que da la asistencia al jugador
    const asisted = (index) => {
        variables.clasesMuestra[index].asistio = true
        setVariables(prev => ({
            ...prev
        }))
    }

    //Funcion que quita la asistencia al jugador
    const notAsisted = (index) => {
        variables.clasesMuestra[index].asistio = false
        setVariables(prev => ({
            ...prev
        }))
    }

    return (
        <div>
            {variables.showClasesMuestra && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            width: "80%",
                            maxWidth: 600,
                            height: 400,
                            borderRadius: 20,
                            padding: 20,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <h2
                            style={{
                                fontSize: 25,
                                fontWeight: "bold",
                                marginBottom: 20,
                                width: "100%",
                                textAlign: "center",
                                fontFamily: fontType.title,
                            }}
                        >
                            Clases muestra
                        </h2>

                        <div
                            style={{
                                flex: 1,
                                overflowY: "auto",
                                width: "100%",
                                paddingRight: 5,
                            }}
                        >
                            {variables.clasesMuestra.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        flexDirection: "row",
                                        paddingTop: 20,
                                        paddingBottom: 20,
                                        paddingLeft: 10,
                                        paddingRight: 10,
                                        borderColor: main,
                                        borderWidth: 2,
                                        borderStyle: "solid",
                                        borderRadius: 10,
                                        marginBottom: 15,
                                    }}
                                >
                                    <div style={{ flex: 0.9 }}>
                                        <p
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: 15,
                                                marginBottom: 5,
                                                fontFamily: fontType.title
                                            }}
                                        >
                                            {item.nombre}
                                        </p>

                                        <input
                                            type="text"
                                            style={{
                                                fontSize: 16,
                                                width: "100%",
                                                padding: 5,
                                                borderRadius: 5,
                                                border: "1px solid #ccc",
                                            }}
                                            placeholder="Comentarios"
                                            defaultValue={item.comentarios_clase}
                                            onChange={(e) => {
                                                const t = e.target.value;
                                                const updated = [...variables.clasesMuestra];
                                                updated[index].comentarios_clase = t;
                                                setVariables((prev) => ({
                                                    ...prev,
                                                    clasesMuestra: updated,
                                                }));
                                            }}
                                        />
                                    </div>

                                    <div style={{ backgroundColor: "transparent" }}>
                                        {item.asistio ? (
                                            <button
                                                style={{
                                                    backgroundColor: "darkred",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: 8,
                                                    padding: 10,
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => notAsisted(index)}
                                            >
                                                <FaTimes size={20} />
                                            </button>
                                        ) : (
                                            <button
                                                style={{
                                                    backgroundColor: main,
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: 8,
                                                    padding: 10,
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => asisted(index)}
                                            >
                                                <FaCheck size={20} />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div
                            style={{
                                marginTop: 20,
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <button
                                style={{
                                    backgroundColor: main,
                                    color: "white",
                                    fontFamily: fontType.title,
                                    fontSize: 16,
                                    border: "none",
                                    borderRadius: 10,
                                    padding: "10px 40px",
                                    cursor: "pointer",
                                }}
                                onClick={onContinue}
                            >
                                CONTINUAR
                            </button>
                        </div>
                    </div>
                </div>
            )
        }
        </div>
    )
}

export default memo(ClasesMuestraConfirm)